import { SorterResult } from 'antd/es/table/interface';
import { Insurer, InsurerFilterParams } from '@/types/admin-insurer';
import { AppBreadcrumb, AppButton, AppContainer, AppPagination } from '../atoms';
import { InsurerTable } from '../molecules';
import { AdminInsurerFilter } from '../organisms';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { Plus } from '../atoms/AppIcon';
import { useNavigate, useParams } from 'react-router-dom';

interface AdminInsurerListTemplateProps {
  data: Insurer[];
  current: number;
  total: number;
  pageSize: number;
  sortInfo?: {
    columnKey?: string;
    order?: 'ascend' | 'descend';
  };
  onChange: (page: number) => void;
  onTableChange?: (sorter: SorterResult<Insurer> | SorterResult<Insurer>[]) => void;
  onSearch?: (filters: InsurerFilterParams) => void;
  breadcrumbItems: BreadcrumbItemType[];
  isLoading?: boolean;
}

const AdminInsurerListTemplate = ({
  data,
  isLoading,
  current,
  total,
  pageSize,
  sortInfo,
  onChange,
  onTableChange,
  onSearch,
  breadcrumbItems,
}: AdminInsurerListTemplateProps) => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const navigate = useNavigate();
  return (
    <AppContainer>
      <main className="space-y-5 px-4">
        <AppBreadcrumb items={breadcrumbItems} />
        <h3 className="text-xl">保険者</h3>
        <AdminInsurerFilter onSearch={onSearch} />
        <AppButton
          type="primary"
          icon={<Plus />}
          onClick={() => navigate(`/${currentSite}/admin/insurers/create`)}
        >
          新規
        </AppButton>
        <div className="bg-white rounded-md border">
          <InsurerTable
            data={data}
            sortInfo={sortInfo}
            onTableChange={onTableChange}
            isLoading={isLoading}
          />
          <div className="flex justify-end p-4">
            <AppPagination
              current={current}
              total={total}
              pageSize={pageSize}
              onChange={onChange}
            />
          </div>
        </div>
      </main>
    </AppContainer>
  );
};

export default AdminInsurerListTemplate;
